exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table>tr>td[data-v-6320f83f]{width:30%;height:30px}.margin-5px[data-v-6320f83f]{margin-right:5px}.width-20px[data-v-6320f83f]{table-layout:fixed;width:20px}.padding-5px[data-v-6320f83f]{padding-right:3%;padding-left:3%}.table-responsive img[data-v-6320f83f]{width:60px}table>tr>td[data-v-6320f83f]:nth-child(odd){font-weight:600}", ""]);

// exports
